//import 'slick-carousel';
import { getIEVersion } from "./utility";

declare var Vimeo: any;

const videoviewitemid = 23812;

const options = {
    id: "469889687",
    title: false,
    portrait: false,
    muted: false,
    loop: false,
    autoplay: true,
    responsive: true,
};

export class HeroVimeo {
    $body: JQuery;
    $popUp: JQuery<Element>;
    videoviewlogpublicid: number;
    clockStart: number;
    videoplayer: any;

    constructor() {
        this.videoplayer = null;
        const ieVersion = getIEVersion();
        this.$body = $("body");
        const $herovideo = $(".hero .video");
        this.$popUp = $herovideo.find(".pop-up");
        this.videoviewlogpublicid = 0;

        const self = this;

        if (ieVersion && ieVersion <= 9) {
            $herovideo.addClass("ie");
            $herovideo.find(".mask").css("filter", "Alpha(Opacity=50)");
        }

        /* Controls */
        $herovideo.find(".play").on("click", function () {
            self.openVideo();
        });

        $herovideo.find(".thumbnail").on("click", function () {
            self.openVideo();
        });

        $herovideo.find(".mask").on("click", function () {
            self.closeVideo();
        });

        $herovideo.find(".player .title i").on("click", function () {
            self.closeVideo();
        });

        window.addEventListener("unload", function (event) {
            self.statsVideoDone();
        });
    }

    openVideo() {
        const self = this;
        this.$popUp.addClass("visible");

        this.play();

        this.$body.addClass("no-scroll").on("touchmove", function (e) {
            e.preventDefault();
        });

        const startday = new Date();
        this.clockStart = startday.getTime();
        $.ajax({
            type: "POST",
            url: "/monitor/create/" + videoviewitemid,
            dataType: "text",
        }).done(function (data) {
            self.videoviewlogpublicid = parseInt(data);
        });
    }

    closeVideo() {
        this.$popUp.removeClass("visible");

        this.pause();

        this.$body.removeClass("no-scroll").off("touchmove");

        this.statsVideoDone();
    }

    play() {
        if (!this.videoplayer) {
            this.createPlayer();
        } else {
            this.videoplayer.play();
        }
    }

    pause() {
        if (this.videoplayer) {
            this.videoplayer.pause();
        }
    }

    createPlayer() {
        if (!this.videoplayer) {
            this.videoplayer = new Vimeo.Player("vimeovideo", options);
            this.videoplayer.setVolume(1);
        }
    }

    statsVideoDone() {
        if (this.videoviewlogpublicid) {
            const data = new FormData();
            data.append(
                "videoviewlogpublicid",
                this.videoviewlogpublicid.toString(),
            );
            data.append("ms", this.getTimeDiff().toString());
            this.videoviewlogpublicid = 0;
            if (navigator.sendBeacon) {
                if (!navigator.sendBeacon("/Monitor/Complete", data)) {
                    HeroVimeo.postBeaconFallback(data);
                }
            } else {
                HeroVimeo.postBeaconFallback(data);
            }

            // reset
            this.videoviewlogpublicid = 0;
        }
    }

    // If for some reason beacons aren't working
    private static postBeaconFallback(data: FormData) {
        $.ajax({
            url: "/Monitor/Complete",
            data: data,
            processData: false,
            contentType: false,
            type: "POST",
        });
    }

    // calculate the elapsed second
    private getTimeDiff(): number {
        const myTime = new Date();
        return myTime.getTime() - this.clockStart;
    }
}
